import React from 'react';
import { colors } from 'seedling/constants';

import { unselectedStrokeColor, unselectedFillColor } from './icon_helpers';

const RatingMixedIcon = ({ width = 20, height = 20, unselected = false }) => {
  const strokeColor = unselected ? unselectedStrokeColor : colors.darkYellow;
  const fillColor = unselected ? unselectedFillColor : colors.veryLightYellow;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
      <g fill="none" fillRule="evenodd">
        <path
          fill={strokeColor}
          fillRule="nonzero"
          d="M10 18.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17zm0 1.5C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"
        />
        <path
          fill={fillColor}
          d="M10 18.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17z"
        />
        <path
          fill={strokeColor}
          fillRule="nonzero"
          d="M14.5 9a.75.75 0 1 1 0 1.5h-9a.75.75 0 1 1 0-1.5h9z"
        />
      </g>
    </svg>
  );
};

export default RatingMixedIcon;
